<script setup lang="ts">
import type { ToasterProps } from '#ui/types';

const i18nHead = useLocaleHead();
const { frontendBaseUrl } = useRuntimeConfig().public;

useHead({
    titleTemplate: title => (title ? withSiteName(title) : 'Fleequid'),
    htmlAttrs: {
        lang: () => i18nHead.value.htmlAttrs!.lang,
    },
    link: () => [...(i18nHead.value.link || [])],
    meta: () => [...(i18nHead.value.meta || [])],
});
useServerSeoMeta({
    ogType: 'website',
    ogSiteName: 'Fleequid',
    ogImage: {
        url: `${frontendBaseUrl}/fleequid.jpg`,
        type: 'image/jpeg',
        width: '1200px',
        height: '630px',
        alt: 'Fleequid',
    },
    twitterCard: 'summary_large_image',
});
const toaster: ToasterProps = { expand: true, position: 'top-right' };
</script>
<template>
    <UApp :toaster="toaster">
        <NuxtLoadingIndicator
            color="repeating-linear-gradient(to right,var(--ui-color-primary-200) 0%,var(--ui-color-primary-500) 50%,var(--ui-color-primary-900) 100%)"
        />
        <NuxtLayout>
            <NuxtPage />
        </NuxtLayout>
    </UApp>
</template>
